
import $ from 'jquery';


var MIN_BREAKPOINT = 768;
var MAX_BREAKPOINT = 1366;
var DROPDOWN_LI = '.nav__item--1.is-dropdown';

$(document).ready(function () {
    if (window.innerWidth >= MIN_BREAKPOINT && window.innerWidth < MAX_BREAKPOINT) {
        $(DROPDOWN_LI).each(function (elem, index) {
            var $menu = $(this).find('.nav__list--2');
            var $span = $(this).find('> span.flyout__visible');
            var $link = $(this).find('> a.nav__link--1');

            //$menu.prepend('<li class="nav__item  nav__item--tabletSwapSpan nav__item--2"><a class="nav__link nav__link--2" href="' + href + '">' + label + '</a></li>');
            $link.addClass('flyout__hidden--sm-md');
            $span.addClass('flyout__visible--sm-md');
        });
    }

    /*var touchy = doesSupportTouch();
    if (touchy) {
        $('.nav__item--panelOverview').addClass('show');
    }

    init();*/
});


function doesSupportTouch() {
    var supportsTouch = false;
    debugger;
    if (('ontouchstart' in window) ||  // iOS & android
        (window.navigator.msPointerEnabled) || // Win8
        ('ontouchstart' in document.documentElement)) // Controversal way to check touch support
    {
        supportsTouch = true;
    }

    return supportsTouch;
}

function init() {

    $(DROPDOWN_LI).hover(function mouseEnterDropdown(e) {
        var $this = $(this);
        if (window.innerWidth > 768) {
            dropdownNavLinkHoverToggleAria($this, true);
        }
    }, function mouseLeaveDropdown(e) {
        var $this = $(this);
        if (window.innerWidth > 768) {
            dropdownNavLinkHoverToggleAria($this, false);
        }
    });
}



function dropdownNavLinkHoverToggleAria($el, ariaValue) {
    if ($el instanceof HTMLElement) {
        throw new Error('Element has to be a jQuery object.');
    }

    if (typeof ariaValue !== 'boolean') {
        throw new Error('Aria value has to be boolean.');
    }

    if (ariaValue) {
        $el.addClass('open');

    } else {
        $el.removeClass('open');
    }

    $el.attr('aria-expanded', ariaValue);
}